<template>
<div>
    <fieldset style="text-align: left">
        <b-card v-if="isForm">
            <form @submit.prevent="uploadTrainingMaterial" enctype="multipart/form-data">
                <input type="hidden" v-model="training_id" />
                <div class="form-group form-row mb-0">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-2">
                                <label style="font-weight:700;color: #000 !important;">
                                    Title
                                    <span style="color:rgba(255, 0, 0, 1);">*</span>
                                </label>
                                <div>
                                    <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" class="form-control" id="inputtext" v-model="materialTitle" placeholder autocomplete="off" />
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6 col-lg-4" v-if="FileDiv == true">
                                <label style="font-weight:700;color: #000 !important;">
                                    Upload
                                    <span style="color:rgba(255, 0, 0, 1);">*</span>
                                </label>
                                <b-form-file ref="file" type="file" name="filetoupload" v-on:change="handleFileUpload($event.target.files)" :state="Boolean(file)" :placeholder="file ? file.name : 'Choose a file...'" drop-placeholder="Drop file here..."></b-form-file>
                            </div>
                            <div class="col-sm-4 col-md-4 col-lg-3" v-if="linkDiv == true">
                                <label style="color: #07a7e19c !important;">Link</label>
                                <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" v-model="materialink" class="form-control" id="inputtext" placeholder />
                            </div>
                            <div class="col-sm-4 col-md-4 col-lg-1 mt-3">
                                <b-button type="submit" class="save-btn btn btn-primary btn-sm d-flex justify-content-left" variant="">Save</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-end mr-0"></div>
            </form>
        </b-card>
        <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f;">
            <form @submit.prevent="updateTrainingMaterial" enctype="multipart/form-data">
                <input type="hidden" v-model="training_id" />
                <div class="form-group form-row mb-0">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-2">
                                <label style="color: #07a7e19c !important;">
                                    Title
                                    <span style="color:rgba(255, 0, 0, 1);">*</span>
                                </label>
                                <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" class="form-control" id="inputtext" v-model="materialTitle" placeholder />
                            </div>

                            <div class="col-sm-4 col-md-4 col-lg-2" v-if="FileDiv == true">
                                <label style="color: #07a7e19c !important;">
                                    File Upload
                                    <span style="color:rgba(255, 0, 0, 1);">*</span>
                                </label>
                                <b-form-file ref="file" type="file" name="filetoupload" v-on:change="handleFileUpload($event.target.files)" :state="Boolean(file)" placeholder="Choose a file..." drop-placeholder="Drop file here..."></b-form-file>
                            </div>

                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div v-if="select11 == 'PDF' || select11 == 'Word' || select11 == 'Html' || select11 == 'PPT'">
                                    <div class="otherMaterial_palceholder">
                                        {{uploadedFile}}
                                    </div>
                                </div>
                                <div v-if="select11 == 'Video'">
                                    <div class="vd-crd">
                                        <video controls>
                                            <source :src="BASEPATHDYNAMIC+'/'+uploadedFile" />
                                            <source :src="BASEPATHDYNAMIC+'/'+uploadedFile" />
                                            Your browser does not support HTML5 video.
                                        </video>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 col-md-4 col-lg-2" v-if="linkDiv == true">
                                <label style="color: #07a7e19c !important;">Link</label>
                                <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" v-model="materialink" class="form-control" id="inputtext" placeholder />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
                <div class="row justify-content-end">
                    <b-button type="submit" class="save-btn d-flex justify-content-end" variant="primary">Update</b-button>
                    <b-button pill v-if="isEditForm" @click="closeEditForm" variant="outline-info" style="border-radius:10px;margin-left:10px">Cancel</b-button>
                </div>
                <input type="hidden" v-model="material_id" />
            </form>
        </b-card>
    </fieldset>
    <!-- <b-card class="mt-3"> -->
    <div class="form-group p-2 mt-2">
        <div class="row">
            <div class="col-sm-12">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>File</th>
                                <th>Title</th>
                                <th>Upload Type</th>
                                <th>File Type</th>
                                <th>Preview</th>
                                <th>Download</th>
                                <th>Uploaded By</th>
                                <th>Created on</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody style="text-align: left">
                            <tr v-for="(material, index) in materialRecords" :key="index">
                                <!-- File Icon -->
                                <td>
                                    <img :src="getFileIcon(material.uploadfile)" alt="File Icon" width="50" height="50" style="object-fit: cover; border-radius: 5px;" />
                                </td>

                                <td class="text-capitalize">
                                    {{ material.title }}
                                </td>

                                <td class="text-capitalize">{{ material.type }}</td>
                                <td>{{ getFileType(material.uploadfile) }}</td>

                                <!-- Preview Column -->
                                <td>
                                    <a @click="previewFile(material.uploadfile)">
                                        <i class="material-icons" style="font-size: 28px; color: #28a745; cursor: pointer;">visibility</i>
                                    </a>
                                </td>

                                <!-- Download Column -->
                                <td @click="downloadFile(material.uploadfile)">

                                    <i class="material-icons" style="font-size: 28px; color: #4285f4; cursor: pointer;">get_app</i>

                                </td>

                                <td v-if="material.trainer_created">
                                    {{ material.trainer_created.name }}
                                </td>
                                <td v-else>N/A</td>
                                <td>{{ material.createdAt | formatDate }}</td>

                                <td>
                                    <a @click="editRecord(material.id)">
                                        <vs-icon class="mr-1" icon="edit" style="color: #007bff; font-size: 20px; font-weight: 600; cursor: pointer;"></vs-icon>
                                    </a>
                                    <a @click="deleteRecord(material.id)">
                                        <vs-icon class="mr-1" icon="delete" style="color: #ff0000c7; font-size: 20px; font-weight: 600; cursor: pointer;"></vs-icon>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
    <b-modal v-model="showImageModal" title="Image Preview" size="lg" hide-footer>
        <div class="text-center">
            <img v-if="previewImageUrl" :src="previewImageUrl" alt="Preview" style="max-width: 100%; max-height: 500px; border-radius: 5px;">
        </div>
    </b-modal>
    <!-- new form popup ends -->
</div>
</template>

<script>
import axios from "axios";


axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

export default {
    data: () => ({
        error: "",
        success: "",
        trainingDetails: [],
        trainingDates: [],
        training_id: "",
        filetoupload: null,
        accademicArr: 1,
        BASEPATHDYNAMIC: "",
        radios1: "Pre Evenet Form",
        popupActivo: false,
        file: "",
        material_id: "",
        search: "",
        errors: [],
        isForm: true,
        isEditForm: false,
        materialTitle: "",
        select11: "",
        materialink: "",
        isFormData: false,
        selected: "",
        uploadedFile: "",
        trainingId: "",
        trainingCode: "",
        updateTraining: [],
        materialRecords: [],
        linkDiv: false,
        FileDiv: true,
        training_status: "",
        showImageModal: false,
        previewImageUrl: "",

    }),

    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;
                this.updateTraining = response.data.training;

                this.trainingMaterial(this.trainingId);

            });

    },
    components: {

    },

    methods: {
        // onclick show wizard steps
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        trainingMaterial: function trainingMaterial(tid) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/traing_material/get/" +
                    JSON.parse(localStorage.getItem("currentUser")).id +
                    "/" + tid

                )
                .then(response => {

                    this.closeLoading();
                    if (response.data.materials) {
                        this.materialRecords = response.data.materials;
                    }
                    if (response.data.trainingDetails) {
                        this.trainingDetails = response.data.trainingDetails;
                        if (response.data.trainingDetails.training) {
                            this.training_id = response.data.trainingDetails.training.id;
                            this.trainingDates = JSON.parse(
                                response.data.trainingDetails.training.TrainingDates
                            );
                        }
                    }
                });
        },
        uploadTrainingMaterial(e) {
            e.preventDefault();
            this.inValid = [];
            let self = this;

            if (!this.materialTitle) {
                this.inValid.push("Title is required.");
            }

            if (!this.materialink && this.linkDiv == true) {
                this.inValid.push("Please enter Link.");
            }
            if (!this.file && this.FileDiv == true) {
                this.inValid.push("Please upload file.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append(
                    "user_id",
                    JSON.parse(localStorage.getItem("currentUser")).id
                );
                formData.append("title", this.materialTitle);
                formData.append("type", this.radios1);
                formData.append("fileType", this.select11);
                formData.append("training_id", this.trainingId);
                formData.append("link", this.materialink);
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/programofficer/upload/trainingmaterial",
                        formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: localStorage.getItem("token"),
                            }
                        }
                    )
                    .then(response => {

                        this.closeLoading();
                        if (response.data.success) {
                            self.$toasted.global.successMsg("Record has been added successfully!");
                            self.resetForm();
                            self.trainingMaterial(this.trainingId);
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.$toasted.global.errorMsg(error);
                    });
            }
        },
        getFileType(filename) {
            const extension = filename.split('.').pop().toLowerCase();
            if (extension === 'pdf') {
                return 'PDF';
            } else if (extension === 'doc' || extension === 'docx') {
                return 'Word';
            } else if (extension === 'ppt' || extension === 'pptx') {
                return 'PPT';
            } else if (extension === 'xls' || extension === 'xlsx') {
                return 'Excel';
            } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') {
                return 'Image';
            } else if (extension === 'mp4' || extension === 'avi' || extension === 'mov' || extension === 'wmv') {
                return 'Video';
            } else if (extension === 'mp3' || extension === 'wav' || extension === 'ogg' || extension === 'flac') {
                return 'Audio';
            } else if (extension === 'html' || extension === 'htm' || extension === 'url') {
                return 'Link';
            } else {
                return 'Unknown';
            }
        },
        updateTrainingMaterial(e) {
            e.preventDefault();
            let self = this;
            this.inValid = [];
            if (!this.materialTitle) {
                this.inValid.push("Title is required.");
            }
            if (!this.radios1) {
                this.inValid.push("Material type is required.");
            }
            if (!this.select11) {
                this.inValid.push("File type is required.");
            }
            if (!this.materialink && this.linkDiv == true) {
                this.inValid.push("Link is required.");
            }
            if (!this.file && this.uploadedFile == "" && this.FileDiv == true) {
                this.inValid.push("Please upload file.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("material_id", this.material_id);
                formData.append(
                    "user_id",
                    JSON.parse(localStorage.getItem("currentUser")).id
                );
                formData.append("title", this.materialTitle);
                formData.append("type", this.radios1);
                formData.append("fileType", this.select11);
                formData.append("link", this.materialink);
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/trainer/update/trainingmaterial",
                        formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: localStorage.getItem("token"),
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);

                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data.success) {
                            self.$toasted.global.successMsg("Record has been updated successfully!");
                            self.resetForm();
                            self.trainingMaterial(this.trainingId);
                            this.isForm = true;
                            this.isEditForm = false;
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            (this.materialTitle = ""),
            (this.radios1 = ""),
            (this.select11 = ""),
            (this.file = ""),
            (this.materialink = "");
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainingmaterial/" +
                    id +
                    "/edit"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.materialTitle = response.data.title;
                        this.radios1 = response.data.type;
                        this.select11 = response.data.fileType;
                        this.materialink = response.data.link;
                        this.uploadedFile = response.data.uploadfile;
                        this.material_id = response.data.id;

                        if (
                            this.select11 == "PDF" ||
                            this.select11 == "Word" ||
                            this.select11 == "Image" ||
                            this.select11 == "PPT"
                        ) {
                            this.uploadedFile = this.uploadedFile.substring(38, 100);
                        }
                    }
                });
        },
        deleteRecord(id) {
            // alert("ID '" +id+ "' is being deleted.");
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(
                                process.env.VUE_APP_BASE_PATH + "/uploadmaterial/delete", {
                                    id: id
                                }
                            )
                            .then(response => {
                                if (response.data.unAuth) {
                                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                                    localStorage.clear();
                                    setTimeout(() => {
                                        this.$router.push("/");
                                    }, 1000);

                                }
                                if (response.data.tokenExpired) {
                                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                                    localStorage.clear();
                                    setTimeout(() => {
                                        this.$router.push("/");
                                    }, 1000);
                                }
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg("Record has been deleted successfully!");
                                    this.error = "";
                                    this.trainingMaterial(this.trainingId);
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.success = "";
                                this.error = error;
                            });
                    }
                });
        },
        handleFileUpload(fileList) {

            this.file = fileList.length > 0 ? fileList[0] : '';
            // var FileSizeMb = this.file.size / Math.pow(1024, 2);
            this.select11 = this.getFileType(fileList[0].name)

        },
        resetForm() {
            (this.materialTitle = ""),
            (this.select11 = ""),
            (this.file = ""),
            (this.materialink = "");
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        successUpload() {
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Files have been Uploaded, consectetur"
            });
        },
        getFileIcon(fileName) {
            if (!fileName) {
                return "https://via.placeholder.com/50"; // Placeholder if no file
            }

            const ext = fileName.split('.').pop().toLowerCase();

            switch (ext) {
                case "pdf":
                    return "https://cdn-icons-png.flaticon.com/512/337/337946.png"; // PDF icon
                case "doc":
                case "docx":
                    return "https://cdn-icons-png.flaticon.com/512/732/732226.png"; // Word icon
                case "ppt":
                case "pptx":
                    return "https://cdn-icons-png.flaticon.com/512/888/888880.png"; // PPT icon
                case "xls":
                case "xlsx":
                    return "https://cdn-icons-png.flaticon.com/512/732/732220.png"; // Excel icon
                case "jpg":
                case "jpeg":
                case "png":
                case "gif":
                    return this.BASEPATHDYNAMIC + "/" + fileName; // Show actual image
                default:
                    return "https://cdn-icons-png.flaticon.com/512/1250/1250595.png"; // Default file icon
            }
        },
        previewFile(fileName) {
            if (!fileName) {
                this.$toasted.global.errorMsg("No image available to preview.");
                return;
            }

            // Ensure correct URL formatting
            this.previewImageUrl = this.BASEPATHDYNAMIC.replace(/\/$/, "") + "/" + fileName.replace(/^\//, "");

            // Supported image types
            const ext = fileName.split('.').pop().toLowerCase();
            if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
                this.showImageModal = true; // Open modal
            } else {
                this.$toasted.global.errorMsg("This is not an image file.");
            }
        },
        downloadFile(fileUrl) {
            if (!fileUrl) {
                this.$toasted.global.errorMsg("File not available.");
                return;
            }

            // Ensure correct file path (Avoid double slashes)
            const fullFilePath = this.BASEPATHDYNAMIC.replace(/\/$/, "") + "/" + fileUrl.replace(/^\//, "");

            // Fetch the file as a Blob to force download
            axios({
                    url: fullFilePath,
                    method: "GET",
                    responseType: "blob", // Forces browser to treat as a binary file
                })
                .then(response => {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"]
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", this.getFileName(fileUrl)); // Correct file name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(() => {
                    this.$toasted.global.errorMsg("Failed to download the file.");
                });
        },

        getFileName(filePath) {
            return filePath ? filePath.split('/').pop() : "downloaded-file";
        }

    },
    watch: {
        select11(text) {
            if (text == 'Weblink') {
                this.linkDiv = true;
                this.FileDiv = false;
            } else {
                this.linkDiv = false;
                this.FileDiv = true;
            }

        },
    }
};
</script>

<style scoped>
#grad1 {
    background-color: #fff;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #f4f4f4;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.card-body {
    background-color: #f4f4f4 !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    padding: 5px !important;
    /* padding-right: 10px; */
    cursor: pointer;
}
</style><style>
span.text-chip.vs-chip--text {
    margin-left: 0px !important;
}

.con-vs-chip.vs-chip-danger.con-color,
.con-vs-chip.vs-chip-success.con-color,
.con-vs-chip.vs-chip-warning.con-color {
    padding: 5px !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    float: none !important;
}
</style>
